/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminPositionStockBalance
 */
export interface OutputAdminPositionStockBalance {
    /**
     * 
     * @type {number}
     * @memberof OutputAdminPositionStockBalance
     */
    stockItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminPositionStockBalance
     */
    stockItemName?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminPositionStockBalance
     */
    stockItemType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminPositionStockBalance
     */
    totalQuantity?: number;
}

/**
 * Check if a given object implements the OutputAdminPositionStockBalance interface.
 */
export function instanceOfOutputAdminPositionStockBalance(value: object): boolean {
    return true;
}

export function OutputAdminPositionStockBalanceFromJSON(json: any): OutputAdminPositionStockBalance {
    return OutputAdminPositionStockBalanceFromJSONTyped(json, false);
}

export function OutputAdminPositionStockBalanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminPositionStockBalance {
    if (json == null) {
        return json;
    }
    return {
        
        'stockItemId': json['stockItemId'] == null ? undefined : json['stockItemId'],
        'stockItemName': json['stockItemName'] == null ? undefined : json['stockItemName'],
        'stockItemType': json['stockItemType'] == null ? undefined : json['stockItemType'],
        'totalQuantity': json['totalQuantity'] == null ? undefined : json['totalQuantity'],
    };
}

export function OutputAdminPositionStockBalanceToJSON(value?: OutputAdminPositionStockBalance | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'stockItemId': value['stockItemId'],
        'stockItemName': value['stockItemName'],
        'stockItemType': value['stockItemType'],
        'totalQuantity': value['totalQuantity'],
    };
}

